import React, { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { Box, Typography } from "@mui/material";

export const FormInputText = ({
  name,
  control,
  label,
  type,
  placeholder,
  defaultValue,
  maxLength,
  className,
  disabled,
  size,
  numberString = false,
  onFocus,
  autofocus,
}) => {
  const handleKeyPress = (event) => {
    if (numberString && !/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue || ""}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "157%",
                color: "var(--neutral-800)",
                textAlign: "left",
                // pb: 1,
              }}
            >
              {label}
            </Typography>

            <TextField
              type={"text"}
              fullWidth
              disabled={disabled}
              onKeyPress={handleKeyPress}
              placeholder={`Enter ${label?.toLowerCase()}`}
              variant="outlined"
              onFocus={onFocus}
              autoFocus={autofocus}
              InputProps={{
                style: {
                  fontSize: "14px !important",
                  opacity: 1,
                  fontWeight: 600,
                  color: "var(--neutral-black)",
                  lineHeight: "157%",
                },
              }}
              inputProps={{
                maxLength: maxLength || 20,
                inputMode: type === "number" ? "numeric" : "text", // Ensures mobile keyboards show numeric input
                pattern: type === "number" ? "[0-9]*" : undefined, // Enforces numeric input
              }}
              value={value}
              onChange={onChange}
              helperText={error ? error.message : ""}
              error={!!error}
              sx={{
                borderRadius: "8px",
                padding: "7px 12px",
                justifyContent: "center",
                display: "inline-flex",
                alignItems: "center",
                width: "100%",
                "&.MuiInputBase-root.MuiOutlinedInput-root::placeholder": {
                  fontSize: "14px",
                  opacity: 1,
                  fontWeight: 500,
                  color: "var(--neutral-700)",
                  lineHeight: "157%",
                },
              }}
              FormHelperTextProps={{
                sx: {
                  textAlign: "left",
                  width: "100%",
                  paddingLeft: "14px",
                },
              }}
            />
          </>
        );
      }}
    />
  );
};
